import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {
  Label,
  Input,
  Button
} from 'reactstrap'
import moment from 'moment'
import TimePicker from 'rc-time-picker'
import 'rc-time-picker/assets/index.css'

class ScheduleCard extends Component {
  constructor(props) {
    super(props)

    this.state = {
      cardFields: this.props.cardFields
    }

    this.STATUSES = {
      'open': 'Öffnungszeiten',
      'by_appointment': 'Nach Vereinbarung',
      'closed': 'Geschlossen'
    }

    this.WEEKDAYS = [
      'monday',
      'tuesday',
      'wednesday',
      'thursday',
      'friday',
      'saturday',
      'sunday'
    ]

    moment.locale('de')

    this.handleTimeChange = this.handleTimeChange.bind(this)
    this.handleSelect = this.handleSelect.bind(this)
    this.returnValue = this.returnValue.bind(this)
  }

  componentWillReceiveProps(newProps) {
    !newProps.isEditing && this.setState({
      cardFields: newProps.cardFields
    })
  }

  returnValue(value) {
    return this.state.cardFields.find(el => value === el.id).fieldValue
  }

  handleTimeChange(ref, momentObj) {
    this.setState(prevState => {
      let cardFields = prevState.cardFields
      cardFields.find(el => el.id === ref).fieldValue = momentObj ? momentObj.format('H:mm:ss') : null

      this.WEEKDAYS.map(day => {
        if (momentObj) {
          if (ref.indexOf(day) > 0) {
            cardFields.find(el => el.id === `opening_hours_${day}_status`).fieldValue = 'open'
          }
        } else {
          if (ref.indexOf(day) > 0) {
            let status = /saturday|sunday/.test(day) ? 'closed' : 'by_appointment'
            let fieldsToCheck = cardFields
                                  .filter(el => el.id.indexOf(`_${day}`) > 0)
                                  .filter(el => el.id.indexOf('status') < 0)
                                  .filter(el => el.fieldValue === null || el.fieldValue === 'null')

            if (fieldsToCheck.length === 4) {
              cardFields.find(el => el.id === `opening_hours_${day}_status`).fieldValue = status
            }
          }
        }
      })

      return cardFields
    })
  }

  handleSelect(ev) {
    let target = ev.target

    this.setState(prevState => {
      let cardFields = prevState.cardFields
      cardFields.find(el => el.id === target.name).fieldValue = target.value

      if (target.value !== 'open') {
        this.WEEKDAYS.map(day => {
          if (target.name.indexOf(day) > 0) {
            let fieldsToReset = cardFields
                                  .filter(el => el.id.indexOf(`_${day}`) > 0)
                                  .filter(el => el.id.indexOf('status') < 0)

            fieldsToReset.map(field => {
              cardFields.find(el => el.id === field.id).fieldValue = null
            })
          }
        })
      }

      return cardFields
    })
  }

  renderHeaders() {
    return [
      <div key="header" className="schedule-card-row">
        <div className="schedule-card-field schedule-card-field-day schedule-card-header">Tag</div>
        <div className="schedule-card-field schedule-card-header">
          Nach Vereinbarung / Öffnungszeiten / Geschlossen
        </div>
        <div className="schedule-card-field schedule-card-header">Öffnungszeiten</div>
        <div className="schedule-card-field schedule-card-header">
          Mittagspause
          <span className="schedule-card-subheader">
            Eine Mittagspause kann, muss jedoch nicht hinterlegt werden.
          </span>
        </div>
      </div>,
      <div key="sub-header" className="schedule-card-row">
        <div className="schedule-card-field schedule-card-field-day"> </div>
        <div className="schedule-card-field schedule-card-header"> </div>
        <div className="schedule-card-field">
          <div className="schedule-card-toFrom">Ab</div>
          <div className="schedule-card-toFrom">Bis</div>
        </div>
        <div className="schedule-card-field">
          <div className="schedule-card-toFrom">Ab</div>
          <div className="schedule-card-toFrom">Bis</div>
        </div>
      </div>
    ]
  }

  renderEditableDay(day) {
    let timePickerFooter = panel => {
      return <div className="time-picker-footer p-2 text-right">
        <Button color="primary" onClick={() => { panel.close() }}>Ok</Button>
        <Button color="danger" outline className="float-left" onClick={() => {
          panel.props.onChange()
          panel.state.value = null
          panel.close()
        }}><i className="icon-trash"></i></Button>
      </div>
    }

    return <div key={day.name} className="schedule-card-row">
            <div className="schedule-card-field schedule-card-field-day">{day.name}</div>
            <div className="schedule-card-field">
              <Input
                type='select'
                name={`opening_hours_${day.day}_status`}
                value={day.status}
                bsSize='sm'
                onChange={this.handleSelect}>
                {Object.keys(this.STATUSES).map(st_key => {
                  return <option key={st_key} value={st_key}>{this.STATUSES[st_key]}</option>
                })}
              </Input>
            </div>
            <div className="schedule-card-field">
              <div className="schedule-card-toFrom">
                <TimePicker
                  format='HH:mm'
                  showSecond={false}
                  allowEmpty={false}
                  onChange={momentObj => { this.handleTimeChange(`opening_hours_${day.day}_start`, momentObj) }}
                  defaultOpenValue={moment('09:00', 'h:mm')}
                  addon={timePickerFooter}
                  value={day.opening && day.opening !== 'null' ? moment(day.opening, 'h:mm:ss') : null} />
              </div>
              <div className="schedule-card-toFrom">
                <TimePicker
                  format='HH:mm'
                  showSecond={false}
                  allowEmpty={false}
                  onChange={momentObj => { this.handleTimeChange(`opening_hours_${day.day}_end`, momentObj) }}
                  defaultOpenValue={moment('18:00', 'h:mm')}
                  addon={timePickerFooter}
                  value={day.closing && day.closing !== 'null' ? moment(day.closing, 'h:mm:ss') : null} />
              </div>
            </div>
            <div className="schedule-card-field">
              <div className="schedule-card-toFrom">
                <TimePicker
                  format='HH:mm'
                  showSecond={false}
                  allowEmpty={false}
                  onChange={momentObj => { this.handleTimeChange(`lunch_break_${day.day}_start`, momentObj) }}
                  defaultOpenValue={moment('12:00', 'h:mm')}
                  addon={timePickerFooter}
                  value={day.lunch && day.lunch !== 'null' ? moment(day.lunch, 'h:mm:ss') : null} />
              </div>
              <div className="schedule-card-toFrom">
                <TimePicker
                  format='HH:mm'
                  showSecond={false}
                  allowEmpty={false}
                  onChange={momentObj => { this.handleTimeChange(`lunch_break_${day.day}_end`, momentObj) }}
                  defaultOpenValue={moment('13:00', 'h:mm')}
                  addon={timePickerFooter}
                  value={day.endLunch && day.endLunch !== 'null' ? moment(day.endLunch, 'h:mm:ss') : null} />
              </div>
            </div>
          </div>
  }

  renderDay(day) {
    return <div key={day.name} className="schedule-card-row">
            <div className="schedule-card-field schedule-card-field-day">{day.name}</div>
            <div className="schedule-card-field">
              {this.STATUSES[day.status]}
            </div>
            <div className="schedule-card-field">
              <div className="schedule-card-toFrom">
                {day.opening && day.opening !== 'null' ? moment(day.opening, 'h:mm:ss').format('H:mm') : '-' }
              </div>
              <div className="schedule-card-toFrom">
                {day.closing && day.closing !== 'null' ? moment(day.closing, 'h:mm:ss').format('H:mm') : '-' }
              </div>
            </div>
            <div className="schedule-card-field">
              <div className="schedule-card-toFrom">
                {day.lunch && day.lunch !== 'null' ? moment(day.lunch, 'h:mm:ss').format('H:mm') : '-' }
              </div>
              <div className="schedule-card-toFrom">
                {day.endLunch && day.endLunch !== 'null' ? moment(day.endLunch, 'h:mm:ss').format('H:mm') : '-' }
              </div>
            </div>
          </div>
  }

  renderDays(editableDays) {
    const daysOfTheWeek = {
      'monday': 'Montag',
      'tuesday': 'Dienstag',
      'wednesday': 'Mittwoch',
      'thursday': 'Donnerstag',
      'friday': 'Freitag',
      'saturday': 'Samstag',
      'sunday': 'Sonntag'
    }

    return this.WEEKDAYS.map(day => {
      return editableDays ? this.renderEditableDay({
        day,
        name: daysOfTheWeek[day],
        opening:  this.state.cardFields.find(el => el.fieldLabel === `opening_hours_${day}_start`).fieldValue,
        closing:  this.state.cardFields.find(el => el.fieldLabel === `opening_hours_${day}_end`).fieldValue,
        lunch:    this.state.cardFields.find(el => el.fieldLabel === `lunch_break_${day}_start`).fieldValue,
        endLunch: this.state.cardFields.find(el => el.fieldLabel === `lunch_break_${day}_end`).fieldValue,
        status:   this.state.cardFields.find(el => el.fieldLabel === `opening_hours_${day}_status`).fieldValue,
      })
      :
      this.renderDay({
        day,
        name: daysOfTheWeek[day],
        opening:  this.state.cardFields.find(el => el.fieldLabel === `opening_hours_${day}_start`).fieldValue,
        closing:  this.state.cardFields.find(el => el.fieldLabel === `opening_hours_${day}_end`).fieldValue,
        lunch:    this.state.cardFields.find(el => el.fieldLabel === `lunch_break_${day}_start`).fieldValue,
        endLunch: this.state.cardFields.find(el => el.fieldLabel === `lunch_break_${day}_end`).fieldValue,
        status:   this.state.cardFields.find(el => el.fieldLabel === `opening_hours_${day}_status`).fieldValue,
      })
    })
  }

  render() {
    return this.props.isEditing || this.props.cardType === 'always-on' ?
      <div className="mb-3" style={{ overflowX: 'auto' }}>
        <div className="schedule-card">
          {this.renderHeaders()}
          {this.renderDays(true)}
        </div>
      </div>
    :
      <div className="mb-3" style={{ overflowX: 'auto' }}>
        <div className="schedule-card">
          {this.renderHeaders()}
          {this.renderDays()}
        </div>
      </div>
  }
}

ScheduleCard.propTypes = {
  cardFields: PropTypes.array,
  isEditing: PropTypes.bool,
  cardType: PropTypes.string
}

export default ScheduleCard


// WEBPACK FOOTER //
// ./src/components/EditableCard/ScheduleCard.js